import { DigitalMenuQrCodeTextInterface, StyleOptionInterface } from "@/interface/business/digital-menu.interface";
import { Translate as $t } from "@/plugins/translate";
import { StyleOption } from "@/modules/business/digital";

export default class DigitalMenuQrCodeText implements DigitalMenuQrCodeTextInterface {
  value: string = $t("digital_menu.scan_placeholder_text");
  font!: StyleOptionInterface;
  constructor(data?) {
    Object.assign(this, data);
    this.font = new StyleOption(data?.font);
  }
}
